import React, { useEffect, useLayoutEffect } from 'react'
import './skills.scss'

function Skills() {
  const devSkills = [
    {
      id: 0,
      name: "Next.js",
    },
    {
      id: 1,
      name: "React.js",
    },
    {
      id: 2,
      name: "Node.js",

    },
    {
      id: 3,
      name: "MongoDB",

    },
    {
      id: 4,
      name: "Solidity",

    },
    {
        id: 5,
        name: "Firebase",
    },
    {
        id: 6,
        name: "HTML",
    },
    {
      id: 7,
      name: "CSS",
    },
    {
        id: 8,
        name: "SASS",
    },
    {
        id: 9,
        name: "JavaScript",
    },
    {
        id: 10,
        name: "Three.js",
    },
    {
        id: 11,
        name: "GSAP",
    },
    {
      id: 12,
      name: "Tailwind",
    },
  ]
  const otherSkills = [
    {
      id: 1,
      name: "C",
    },
    {
      id: 2,
      name: "C++",
    },
    {
      id: 2,
      name: "Python",
    },
  ]
  const tools = [
    {
      id: 1,
      name: "VM Instances (GCP)",
    },
    {
      id: 2,
      name: "Git",
    },
    {
      id: 3,
      name: "VSCode",
    },
    {
      id: 4,
      name: "Remix",
    },
    {
      id: 5,
      name: "Figma",
    },
    {
      id: 6,
      name: "Blender",
    }
  ]
  const certificates = [
    {
      id: 1,
      name: "Problem Solving (Basic) - HackerRank",
      imgUrl: "assets/cert-2.png",
      url:"https://www.hackerrank.com/certificates/328f23feb8f5"
    },
    {
      id: 2,
      name: "CSS Proficiency - HackerRank",
      imgUrl: "assets/cert-1.png",
      url:"https://www.hackerrank.com/certificates/94459c679bde"
    },
  ]

  useLayoutEffect(() => {
    const cursor = document.querySelector(".cursor")
    const certificateLinks = document.querySelectorAll(".certificates-container")

    certificateLinks.forEach((link) => {
      link.addEventListener("mouseover", () => {
                cursor.style.scale = "1"
                cursor.style.display = "block"
            })
            link.addEventListener("mouseout", () => {
                cursor.style.scale = "0"
            })
        })
    })

  return (
    <>
    <div>
      <section id='skills-section'>
        <div className='skills-section-wrapper'>
          <header>
              <h1>/ Web</h1>
          </header>
          <div className='skills-container'>                     
              {devSkills.map((skill) => (
                <div className={`skill-box skill-box-${skill.id}`} key={skill.id}>
                  <span>{skill.name}</span>
                </div>
              ))}           
          </div>
          <header>
              <h1>/ Other</h1>
          </header>
          <div className='skills-container o-skills-container'>                     
              {otherSkills.map((oSkill) => (
                <div className={`skill-box other-skill-box-${oSkill.id}`} key={oSkill.id}>
                  <span>{oSkill.name}</span>
                </div>
              ))}           
          </div>
          <header>
              <h1>/ Tools</h1>
          </header>
          <div className='skills-container tools-container'>                     
              {tools.map((tool) => (
                <div className={`skill-box tool-box-${tool.id}`} key={tool.id}>
                  <span>{tool.name}</span>
                </div>
              ))}           
          </div>
          {/* <header>
              <h1>/ Certifications</h1>
          </header>
          <div className='skills-container certificates-container'>                     
              {certificates.map((certificate) => (
                <a href={ certificate.url } className={`skill-box certificate-box-${certificate.id}`} key={certificate.id}>
                  <span>{certificate.name}</span>
                </a>
              ))}         
          </div> */}
        </div>
      </section>
    </div>
    </>
  )
}

export default Skills